<template>
  <div
    id="accessories"
    class="accessories"
  >
    <div class="accessories-left">
      <object
        ref="drawing"
        class="accessories-drawing"
        type="image/svg+xml"
        data="accessories-drawing.svg"
        width="250.3707733"
        height="383.4519958"
        @load="onDrawingLoad"
      />
    </div>
    <div class="accessories-body">
      <table class="accessories-table">
        <thead>
          <th>Комплектующие</th>
          <th>₽/шт</th>
          <th>Кол-во</th>
          <th>Стоимость/₽</th>
        </thead>
      </table>
      <div
        v-for="(row, i) in itemsByRows"
        :key="i"
        class="accessories-row"
      >
        <div class="accessories-num">
          РЯД {{ i + 1 }}
        </div>
        <table class="accessories-table">
          <tbody>
            <tr
              v-for="(item, j) in row.items"
              :key="j"
              @mouseenter="setDrawingDisplay(item.type + '_hover', true)"
              @mouseleave="setDrawingDisplay(item.type + '_hover', false)"
            >
              <td><span class="accessories-pseudo">{{ item.name }}</span></td>
              <td>{{ item.price }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ (item.price * item.quantity).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
        <div class="accessories-summary">
          Стоимость ряда {{ i + 1 }}
          <div class="accessories-summaryPrice">
            {{ row.price }} ₽
          </div>
        </div>
      </div>
    </div>
    <div class="accessories-right">
      <div class="accessories-priceLabel">
        Итого:
      </div>
      <div class="accessories-price">
        {{ price }} ₽
      </div>
      <div class="accessories-icons">
        <a
          href="#"
          class="accessories-icon_print"
          title="Печать"
          @click.prevent="$emit('print')"
        />
        <a
          href="#"
          class="accessories-icon_download"
          title="Скачать"
          @click.prevent="$emit('download')"
        />
        <a
          href="#modal-calc-email"
          class="accessories-icon_mail"
          data-fancybox
          title="Отправить на почту"
        />
        <a
          v-if="role === 'dealer'"
          href="#modal-calc-invoice"
          class="accessories-icon_dealer"
          data-fancybox
          title="Выписать счет для дилера"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      itemsByRows: Array,
      wedgeAnchors: Boolean,
      pdfData: String,
      role: String
    },
    computed: {
      price() {
        return this.itemsByRows.reduce((a, c) => a + +c.price, 0).toFixed(2);
      },
      items() {
        return this.itemsByRows.reduce((a, c) => a.concat(c.items), []);
      },
      types() {
        return this.items.reduce((a, c) => ({...a, [c.type]: true}), {
          tier_shelf: false,
          tier_flooring: false,
        });
      },
      resetTypes() {
        return {
          'polki-raznie': false,
          'polki-metall': false,
          'polki-metal-orange': false,
          'polki-metall-orange': false,
          'polki-plywood': false,
          'polki': false,
          'polki-plywood-orange': false,
          'polki-orange': false,
        };
      },
    },
    watch: {
      types() {
        this.updateTypes();
      },
    },
    methods: {
      updateTypes() {
        for (const type in this.resetTypes) {
          this.setDrawingDisplay(type, this.resetTypes[type]);
        }
        for (const type in this.types) {
          this.setDrawingDisplay(type, this.types[type]);
        }
      },
      onDrawingLoad(e) {
        this.updateTypes();
      },
      getDrawingElement(id) {
        try {
          return this.$refs.drawing.getSVGDocument().getElementById(id);
        } catch(e) {
          return null;
        }
      },
      setElementDisplay(id, visible) {
        const el = this.getDrawingElement(id);
        if (el) {
          el.style.display = (visible ? 'block' : 'none');
        }
      },
      setDrawingDisplay(type, visible) {
        const typeMap = {
          rack_kit_hover: ['stoiki'],
          beam_coupler_hover: ['styajki'],
          tier_shelf: this.types.tier_flooring ? ['polki-raznie'] : ['polki-metall'],
          tier_shelf_hover: this.types.tier_flooring ? ['polki-metal-orange'] : ['polki-metall-orange'],
          tier_flooring: this.types.tier_shelf ? ['polki-plywood'] : ['polki'],
          tier_flooring_hover: this.types.tier_shelf ? ['polki-plywood-orange'] : ['polki-orange'],
          cross_beam_hover: ['balki-poperechnie-orange'],
          longitudinal_beam_hover: ['balki-prodolnie-orange'],
        };

        const types = typeMap[type] || [type];
        for (const type of types) {
          this.setElementDisplay(type, visible);
        }
      },
    },
  }
</script>

<style scoped>
  .accessories {
    display: flex;
    margin-top: 50px;
  }
  .accessories-left {
    width: 392px;
  }
  .accessories-body {
    flex: 1;
    margin-top: 20px;
  }
  .accessories-right {
    margin-top: 20px;
    margin-left: 30px;
    width: 226px;
  }
  .accessories-drawing {
    margin-left: 50px;
  }
  .accessories-table {
    width: 558px;
    font-size: 14px;
    border-collapse: collapse;
    table-layout: fixed;
  }
  .accessories-table th:nth-child(2),
  .accessories-table td:nth-child(2) {
    width: 88px;
  }
  .accessories-table th:nth-child(3),
  .accessories-table td:nth-child(3) {
    width: 77px;
  }
  .accessories-table th:nth-child(4),
  .accessories-table td:nth-child(4) {
    width: 139px;
  }
  .accessories-table th {
    padding: 14px;
    white-space: nowrap;
    text-align: left;
    font-weight: normal;
    background: #F6F6F6;
  }
  .accessories-table td {
    padding: 8px 14px;
  }
  .accessories-table tr:nth-child(2n + 1) td {
    background: #F6F6F6;
  }
  .accessories-table tr:hover {
    color: #0B53B3;
    cursor: pointer;
  }
  .accessories-pseudo {
    font-weight: bold;
    border-bottom: 1px dashed #333333;
  }
  .accessories-num {
    margin: 16px 14px 13px;
    font-weight: bold;
    text-transform: uppercase;
    color: #A7A7A7;
  }
  .accessories-summary {
    margin: 16px 0 40px;
    padding: 16px 14px;
    background: #F6F6F6;
  }
  .accessories-summaryPrice {
    float: right;
  }
  .accessories-priceLabel {
    font-weight: bold;
    font-size: 18px;
    text-transform: uppercase;
  }
  .accessories-price {
    margin-bottom: 46px;
    font-weight: bold;
    font-size: 30px;
  }
  .accessories-icons {
    margin-left: -6px;
  }
  .accessories-icon_print {
    display: inline-block;
    vertical-align: middle;
    width: 36px;
    height: 36px;
    background: url(../../public/icons/print.svg) no-repeat center center;
  }
  .accessories-icon_download {
    display: inline-block;
    vertical-align: middle;
    width: 36px;
    height: 36px;
    background: url(../../public/icons/download.svg) no-repeat center center;
  }
  .accessories-icon_mail {
    display: inline-block;
    vertical-align: middle;
    width: 36px;
    height: 36px;
    background: url(../../public/icons/mail.svg) no-repeat center center;
  }
  .accessories-icon_dealer {
    display: inline-block;
    vertical-align: middle;
    width: 36px;
    height: 36px;
    background: url(../../public/icons/dealer.png) no-repeat center center;
  }
</style>
